import React from "react";
import SummaryDetailsItem from "../../../Common/SummaryDetailsItem/SummaryDetailsItem";
import SummaryDetailsProps from "../../../../../types/SummaryDetailsProps";

const SummaryDetailsTravel = ({ caseData }: SummaryDetailsProps) => {
  return (
    <>
      <SummaryDetailsItem fieldPath={"reasonForDispute"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"contractNumber"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"bookingDate"} caseData={caseData} fieldType={"date"} />
      <SummaryDetailsItem fieldPath={"journeyStart"} caseData={caseData} fieldType={"date"} />
      <SummaryDetailsItem fieldPath={"journeyEnd"} caseData={caseData} fieldType={"date"} />

      {caseData.reasonForDispute === "cancelled" && (
        <>
          <SummaryDetailsItem fieldPath={"contractualPartnerHasCancelled"} caseData={caseData} />

          {caseData.contractualPartnerHasCancelled === "yes" && (
            <SummaryDetailsItem fieldPath={"contractualPartnerCancellationDate"} caseData={caseData} fieldType={"date"} />
          )}
          <SummaryDetailsItem fieldPath={"buyerPaidStatus"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"buyerPaidDate"} caseData={caseData} fieldType={"date"} />
          <SummaryDetailsItem fieldPath={"buyerPaidAmount"} caseData={caseData} fieldType={"money"} />
        </>
      )}
    </>
  );
};

export default SummaryDetailsTravel;
